export const exceptionModal = {
  exceptionModal: {
    exceptionModalTitle: "Oops! We had a problem.",
    exceptionModalSubtitle:
      "For some reason we couldn't reset your plan now, but we are working on this problem and soon it will be fixed.",
    exceptionModalButton: "Ok",
  },
};
